import React, { useMemo, useState } from 'react';
import { useProjectResources } from '~/modules/common/hooks';
import { ResourceAllocationStatus } from '~/types';

export const mapOptions = resources =>
  resources.map(resource => ({
    ...resource,
    key: resource.displayText,
    label: resource.displayText,
    value: resource.id
  }));

export const matchOption = (options, term) => {
  const projectResource = options.find(
    ({ key, id = '' }) =>
      key.toLowerCase() === term.toLowerCase() ||
      id.toLowerCase() === term.toLowerCase()
  );

  return projectResource || null;
};

export const getProjectResourceSuggestions = options => async phrase =>
  options.filter(
    option =>
      option.label.toLowerCase().includes(phrase.toLowerCase()) ||
      option.slug.toLowerCase().includes(phrase.toLowerCase())
  );
const withCriteriaProvider = (tag, context, projectId) => BaseComponent => ({
  ...props
}) => {
  const { searchCriteria: { criterions = {} } = {} } = props;
  const [selected, setSelected] = useState(criterions[tag] || []);
  const {
    resources: { items: projectResources = [] } = {}
  } = useProjectResources({
    projectId,
    allocationStatusList: [
      ResourceAllocationStatus.Draft,
      ResourceAllocationStatus.Proposed,
      ResourceAllocationStatus.Committed,
      ResourceAllocationStatus.Rejected
    ]
  });
  const options = mapOptions(projectResources);

  const value = useMemo(
    () => ({
      options,
      matchOption,
      selected,
      setSelected,
      suggestions: getProjectResourceSuggestions(options)
    }),
    [options, selected]
  );

  return (
    <context.Provider value={value}>
      <BaseComponent {...props} />
    </context.Provider>
  );
};

const makeCriteriaProvider = (tag, context, projectId) =>
  withCriteriaProvider(tag, context, projectId);

export default makeCriteriaProvider;
